(function () {
  var popup = document.getElementById('ifa2026-contact-popup');
  if (!popup) return;

  if (popup.parentNode !== document.body) {
    document.body.appendChild(popup);
  }

  var contexts = {
    retail: {
      label: 'RETAIL OPPORTUNITY',
      text: 'Discuss category fit, in-store placement, merchandising, launch support and ecommerce opportunities with the Playermaker partnerships team.',
      subject: 'Playermaker retail opportunity'
    },
    distribution: {
      label: 'DISTRIBUTION PARTNERSHIP',
      text: 'Discuss market coverage, routes to market and distribution opportunities with the Playermaker partnerships team.',
      subject: 'Playermaker distribution opportunity'
    },
    evaluation: {
      label: 'PRODUCT EVALUATION',
      text: 'Arrange a focused demonstration or product evaluation for your buying, category or commercial team.',
      subject: 'Playermaker product evaluation request'
    }
  };

  var contacts = {
    steve: 'steve.muttram@playermaker.com',
    jansen: 'jansen.redhead@playermaker.com'
  };

  var contextText = popup.querySelector('[data-contact-context-text]');
  var contextLabel = popup.querySelector('[data-contact-context-label]');
  var emailButtons = popup.querySelectorAll('[data-contact-email]');
  var openers = document.querySelectorAll('[data-ifa2026-contact-open]');
  var closers = popup.querySelectorAll('[data-ifa2026-contact-close]');

  function isOpen() {
    return popup.classList.contains('is-open');
  }

  function updateEmailLinks(subject) {
    emailButtons.forEach(function (button) {
      var key = button.getAttribute('data-contact-email');
      var email = contacts[key];
      if (!email) return;
      button.href = 'mailto:' + email + '?subject=' + encodeURIComponent(subject);
    });
  }

  function openPopup(contextKey) {
    var context = contexts[contextKey] || contexts.retail;
    if (!contextText || !contextLabel) return;

    contextText.textContent = context.text;
    contextLabel.textContent = context.label;
    updateEmailLinks(context.subject);

    popup.removeAttribute('hidden');
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ifa2026-contact-open');

    var closeButton = popup.querySelector('.ifa2026-contact-popup__close');
    if (closeButton) closeButton.focus();
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    popup.setAttribute('hidden', '');
    document.body.classList.remove('ifa2026-contact-open');
  }

  openers.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      openPopup(button.getAttribute('data-contact-context'));
    });
  });

  closers.forEach(function (element) {
    element.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) {
      closePopup();
    }
  });
})();
